export default "__VITE_ASSET__Dl$r90kU__"